import {useEffect, useState} from "react";
// import { useDispatch, useSelector } from "react-redux";
import {Outlet, Route, useNavigate} from "react-router-dom";
import axios from "../service/service"
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner";
import Dashboard from "../pages/DashboardPage/DashboardPage";
// import { handelHeaderAndAsideData } from "../HandleSlice/HandleSlice";

export const PrivateRoutes = () => {
    // const [checkLogin, setCheckLogin] = useState(false);
    // const [isLoading, setIsLoading] = useState(true);

    // // const dispatch = useDispatch()

    // const navigate = useNavigate()


    // const loadData = async () => {
    //   if (localStorage.getItem("projectURL")) {
    //     await axios
    //       .get("/home-admin")
    //       .then((res) => {
    //         localStorage.setItem(
    //           "home_admin_data",
    //           JSON.stringify(res.data.schema)
    //         );
    //         console.log(res.data.schema, "ppppppppppppppppppppppppppppppppppppppppppp")
    //         // dispatch(handelHeaderAndAsideData(res.data.schema))
    //         setCheckLogin(true);
    //         setIsLoading(false);
    //       })
    //       .catch((e) => {
    //         console.log(e);
    //         setIsLoading(false);
    //       });
    //   } else { setIsLoading(false); }
    // };

    // useEffect(() => {
    //   setIsLoading(true);
    //   loadData();
    //   localStorage.setItem("customUpdateState", "false")
    // }, []);

    // if (isLoading) {
    //   return <LoadingSpinner />;
    // }


    // // const data = useSelector((state) => state.hamberger)
    // if (checkLogin) {
    //   navigate("/")
    // }
    // else {
    return <Outlet/>;
    //}
};
